(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'kotlinx-coroutines-core', 'kvision-js-legacy', 'kotlin-multiplatform-diff-js-legacy'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('kotlinx-coroutines-core'), require('kvision-js-legacy'), require('kotlin-multiplatform-diff-js-legacy'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-state-flow-js-legacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-kvision-state-flow-js-legacy'.");
    }if (typeof this['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-state-flow-js-legacy'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'kvision-kvision-state-flow-js-legacy'.");
    }if (typeof this['kvision-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-state-flow-js-legacy'. Its dependency 'kvision-js-legacy' was not found. Please, check whether 'kvision-js-legacy' is loaded prior to 'kvision-kvision-state-flow-js-legacy'.");
    }if (typeof this['kotlin-multiplatform-diff-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-state-flow-js-legacy'. Its dependency 'kotlin-multiplatform-diff-js-legacy' was not found. Please, check whether 'kotlin-multiplatform-diff-js-legacy' is loaded prior to 'kvision-kvision-state-flow-js-legacy'.");
    }root['kvision-kvision-state-flow-js-legacy'] = factory(typeof this['kvision-kvision-state-flow-js-legacy'] === 'undefined' ? {} : this['kvision-kvision-state-flow-js-legacy'], kotlin, this['kotlinx-coroutines-core'], this['kvision-js-legacy'], this['kotlin-multiplatform-diff-js-legacy']);
  }
}(this, function (_, Kotlin, $module$kotlinx_coroutines_core, $module$kvision_js_legacy, $module$kotlin_multiplatform_diff_js_legacy) {
  'use strict';
  var $$importsForInline$$ = _.$$importsForInline$$ || (_.$$importsForInline$$ = {});
  var coroutines = $module$kotlinx_coroutines_core.kotlinx.coroutines;
  var SupervisorJob = $module$kotlinx_coroutines_core.kotlinx.coroutines.SupervisorJob_5dx9e$;
  var CoroutineScope = $module$kotlinx_coroutines_core.kotlinx.coroutines.CoroutineScope_1fupul$;
  var defineInlineFunction = Kotlin.defineInlineFunction;
  var wrapFunction = Kotlin.wrapFunction;
  var cancel = $module$kotlinx_coroutines_core.kotlinx.coroutines.cancel_q2ti5d$;
  var Unit = Kotlin.kotlin.Unit;
  var Container = $module$kvision_js_legacy.io.kvision.core.Container;
  var CoroutineImpl = Kotlin.kotlin.coroutines.CoroutineImpl;
  var onEach = $module$kotlinx_coroutines_core.kotlinx.coroutines.flow.onEach_706ovd$;
  var launchIn = $module$kotlinx_coroutines_core.kotlinx.coroutines.flow.launchIn_wegvf8$;
  var Display = $module$kvision_js_legacy.io.kvision.core.Display;
  var simplePanel = $module$kvision_js_legacy.io.kvision.panel.simplePanel_jhiteo$;
  var ensureNotNull = Kotlin.ensureNotNull;
  var SimplePanel = $module$kvision_js_legacy.io.kvision.panel.SimplePanel;
  var first = Kotlin.kotlin.collections.first_2p1efm$;
  var emptyList = Kotlin.kotlin.collections.emptyList_287e2$;
  var toList = Kotlin.kotlin.collections.toList_7wnvza$;
  var equals = Kotlin.equals;
  var numberToInt = Kotlin.numberToInt;
  var numberToDouble = Kotlin.numberToDouble;
  var checkIndexOverflow = Kotlin.kotlin.collections.checkIndexOverflow_za3lpa$;
  var COROUTINE_SUSPENDED = Kotlin.kotlin.coroutines.intrinsics.COROUTINE_SUSPENDED;
  var SharingStarted = $module$kotlinx_coroutines_core.kotlinx.coroutines.flow.SharingStarted;
  var stateIn = $module$kotlinx_coroutines_core.kotlinx.coroutines.flow.stateIn_928gk7$;
  var FlowCollector = $module$kotlinx_coroutines_core.kotlinx.coroutines.flow.FlowCollector;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var Flow = $module$kotlinx_coroutines_core.kotlinx.coroutines.flow.Flow;
  var KVScope;
  function initWidgetScope$lambda(closure$widget) {
    return function () {
      if (closure$widget.kvscope != null) {
        cancel(closure$widget.kvscope);
        closure$widget.kvscope = null;
      }return Unit;
    };
  }
  function initWidgetScope(widget) {
    if (widget.kvscope == null) {
      widget.kvscope = CoroutineScope(coroutines.Dispatchers.Default.plus_1fupul$(SupervisorJob()));
      widget.addBeforeDisposeHook_o14v8n$(initWidgetScope$lambda(widget));
    }}
  function bind$lambda(closure$removeChildren, this$bind, closure$factory, closure$stateFlow) {
    return function () {
      var tmp$, tmp$_0;
      if (closure$removeChildren)
        (tmp$_0 = Kotlin.isType(tmp$ = this$bind, Container) ? tmp$ : null) != null ? tmp$_0.disposeAll() : null;
      closure$factory(this$bind, closure$stateFlow.value);
      return Unit;
    };
  }
  function bind$lambda$lambda(this$bind, closure$removeChildren, closure$factory, closure$it) {
    return function () {
      var tmp$, tmp$_0;
      if (this$bind.kvscope != null) {
        if (closure$removeChildren)
          (tmp$_0 = Kotlin.isType(tmp$ = this$bind, Container) ? tmp$ : null) != null ? tmp$_0.disposeAll() : null;
        closure$factory(this$bind, closure$it);
      }return Unit;
    };
  }
  function Coroutine$bind$lambda(closure$skip_0, this$bind_0, closure$removeChildren_0, closure$factory_0, it_0, continuation_0) {
    CoroutineImpl.call(this, continuation_0);
    this.exceptionState_0 = 1;
    this.local$closure$skip = closure$skip_0;
    this.local$this$bind = this$bind_0;
    this.local$closure$removeChildren = closure$removeChildren_0;
    this.local$closure$factory = closure$factory_0;
    this.local$it = it_0;
  }
  Coroutine$bind$lambda.$metadata$ = {kind: Kotlin.Kind.CLASS, simpleName: null, interfaces: [CoroutineImpl]};
  Coroutine$bind$lambda.prototype = Object.create(CoroutineImpl.prototype);
  Coroutine$bind$lambda.prototype.constructor = Coroutine$bind$lambda;
  Coroutine$bind$lambda.prototype.doResume = function () {
    do
      try {
        switch (this.state_0) {
          case 0:
            if (!this.local$closure$skip.v) {
              return this.local$this$bind.singleRenderAsync_o14v8n$(bind$lambda$lambda(this.local$this$bind, this.local$closure$removeChildren, this.local$closure$factory, this.local$it)), Unit;
            } else {
              return this.local$closure$skip.v = false, Unit;
            }

          case 1:
            throw this.exception_0;
          default:this.state_0 = 1;
            throw new Error('State Machine Unreachable execution');
        }
      } catch (e) {
        if (this.state_0 === 1) {
          this.exceptionState_0 = this.state_0;
          throw e;
        } else {
          this.state_0 = this.exceptionState_0;
          this.exception_0 = e;
        }
      }
     while (true);
  };
  function bind$lambda_0(closure$skip_0, this$bind_0, closure$removeChildren_0, closure$factory_0) {
    return function (it_0, continuation_0, suspended) {
      var instance = new Coroutine$bind$lambda(closure$skip_0, this$bind_0, closure$removeChildren_0, closure$factory_0, it_0, continuation_0);
      if (suspended)
        return instance;
      else
        return instance.doResume(null);
    };
  }
  function bind($receiver, stateFlow, removeChildren, runImmediately, factory) {
    if (removeChildren === void 0)
      removeChildren = true;
    if (runImmediately === void 0)
      runImmediately = true;
    initWidgetScope($receiver);
    if (runImmediately) {
      $receiver.singleRenderAsync_o14v8n$(bind$lambda(removeChildren, $receiver, factory, stateFlow));
    }var skip = {v: true};
    launchIn(onEach(stateFlow, bind$lambda_0(skip, $receiver, removeChildren, factory)), $receiver.kvscope);
    return $receiver;
  }
  function unsafeFlow$ObjectLiteral(closure$block) {
    this.closure$block = closure$block;
  }
  function Coroutine$collect_42ocv1$($this, collector_0, continuation_0) {
    CoroutineImpl.call(this, continuation_0);
    this.exceptionState_0 = 1;
    this.$this = $this;
    this.local$collector = collector_0;
  }
  Coroutine$collect_42ocv1$.$metadata$ = {kind: Kotlin.Kind.CLASS, simpleName: null, interfaces: [CoroutineImpl]};
  Coroutine$collect_42ocv1$.prototype = Object.create(CoroutineImpl.prototype);
  Coroutine$collect_42ocv1$.prototype.constructor = Coroutine$collect_42ocv1$;
  Coroutine$collect_42ocv1$.prototype.doResume = function () {
    do
      try {
        switch (this.state_0) {
          case 0:
            this.state_0 = 2;
            this.result_0 = this.$this.closure$block(this.local$collector, this);
            if (this.result_0 === COROUTINE_SUSPENDED)
              return COROUTINE_SUSPENDED;
            continue;
          case 1:
            throw this.exception_0;
          case 2:
            return;
          default:this.state_0 = 1;
            throw new Error('State Machine Unreachable execution');
        }
      } catch (e) {
        if (this.state_0 === 1) {
          this.exceptionState_0 = this.state_0;
          throw e;
        } else {
          this.state_0 = this.exceptionState_0;
          this.exception_0 = e;
        }
      }
     while (true);
  };
  unsafeFlow$ObjectLiteral.prototype.collect_42ocv1$ = function (collector_0, continuation_0, suspended) {
    var instance = new Coroutine$collect_42ocv1$(this, collector_0, continuation_0);
    if (suspended)
      return instance;
    else
      return instance.doResume(null);
  };
  unsafeFlow$ObjectLiteral.$metadata$ = {kind: Kind_CLASS, interfaces: [Flow]};
  function Coroutine$unsafeTransform$lambda$lambda(closure$transform_0, this$_0, value_0, continuation_0) {
    CoroutineImpl.call(this, continuation_0);
    this.exceptionState_0 = 1;
    this.local$closure$transform = closure$transform_0;
    this.local$this$ = this$_0;
    this.local$value = value_0;
  }
  Coroutine$unsafeTransform$lambda$lambda.$metadata$ = {kind: Kotlin.Kind.CLASS, simpleName: null, interfaces: [CoroutineImpl]};
  Coroutine$unsafeTransform$lambda$lambda.prototype = Object.create(CoroutineImpl.prototype);
  Coroutine$unsafeTransform$lambda$lambda.prototype.constructor = Coroutine$unsafeTransform$lambda$lambda;
  Coroutine$unsafeTransform$lambda$lambda.prototype.doResume = function () {
    do
      try {
        switch (this.state_0) {
          case 0:
            this.state_0 = 2;
            this.result_0 = this.local$closure$transform(this.local$this$, this.local$value, this);
            if (this.result_0 === COROUTINE_SUSPENDED)
              return COROUTINE_SUSPENDED;
            continue;
          case 1:
            throw this.exception_0;
          case 2:
            return Unit;
          default:this.state_0 = 1;
            throw new Error('State Machine Unreachable execution');
        }
      } catch (e) {
        if (this.state_0 === 1) {
          this.exceptionState_0 = this.state_0;
          throw e;
        } else {
          this.state_0 = this.exceptionState_0;
          this.exception_0 = e;
        }
      }
     while (true);
  };
  function unsafeTransform$lambda$lambda(closure$transform_0, this$_0) {
    return function (value_0, continuation_0, suspended) {
      var instance = new Coroutine$unsafeTransform$lambda$lambda(closure$transform_0, this$_0, value_0, continuation_0);
      if (suspended)
        return instance;
      else
        return instance.doResume(null);
    };
  }
  function Coroutine$unsafeTransform$lambda(closure$transform_0, this$unsafeTransform_0, $receiver_0, controller, continuation_0) {
    CoroutineImpl.call(this, continuation_0);
    this.$controller = controller;
    this.exceptionState_0 = 1;
    this.local$closure$transform = closure$transform_0;
    this.local$this$unsafeTransform = this$unsafeTransform_0;
    this.local$$receiver = $receiver_0;
  }
  Coroutine$unsafeTransform$lambda.$metadata$ = {kind: Kotlin.Kind.CLASS, simpleName: null, interfaces: [CoroutineImpl]};
  Coroutine$unsafeTransform$lambda.prototype = Object.create(CoroutineImpl.prototype);
  Coroutine$unsafeTransform$lambda.prototype.constructor = Coroutine$unsafeTransform$lambda;
  Coroutine$unsafeTransform$lambda.prototype.doResume = function () {
    do
      try {
        switch (this.state_0) {
          case 0:
            this.state_0 = 2;
            this.result_0 = this.local$this$unsafeTransform.collect_42ocv1$(new FlowCollector(unsafeTransform$lambda$lambda(this.local$closure$transform, this.local$$receiver)), this);
            if (this.result_0 === COROUTINE_SUSPENDED)
              return COROUTINE_SUSPENDED;
            continue;
          case 1:
            throw this.exception_0;
          case 2:
            return this.result_0;
          default:this.state_0 = 1;
            throw new Error('State Machine Unreachable execution');
        }
      } catch (e) {
        if (this.state_0 === 1) {
          this.exceptionState_0 = this.state_0;
          throw e;
        } else {
          this.state_0 = this.exceptionState_0;
          this.exception_0 = e;
        }
      }
     while (true);
  };
  function unsafeTransform$lambda(closure$transform_0, this$unsafeTransform_0) {
    return function ($receiver_0, continuation_0, suspended) {
      var instance = new Coroutine$unsafeTransform$lambda(closure$transform_0, this$unsafeTransform_0, $receiver_0, this, continuation_0);
      if (suspended)
        return instance;
      else
        return instance.doResume(null);
    };
  }
  function Coroutine$map$lambda(closure$transform_0, $receiver_0, value_0, controller, continuation_0) {
    CoroutineImpl.call(this, continuation_0);
    this.$controller = controller;
    this.exceptionState_0 = 1;
    this.local$closure$transform = closure$transform_0;
    this.local$$receiver = $receiver_0;
    this.local$value = value_0;
  }
  Coroutine$map$lambda.$metadata$ = {kind: Kotlin.Kind.CLASS, simpleName: null, interfaces: [CoroutineImpl]};
  Coroutine$map$lambda.prototype = Object.create(CoroutineImpl.prototype);
  Coroutine$map$lambda.prototype.constructor = Coroutine$map$lambda;
  Coroutine$map$lambda.prototype.doResume = function () {
    do
      try {
        switch (this.state_0) {
          case 0:
            this.state_0 = 2;
            this.result_0 = this.local$closure$transform(this.local$value, this);
            if (this.result_0 === COROUTINE_SUSPENDED)
              return COROUTINE_SUSPENDED;
            continue;
          case 1:
            throw this.exception_0;
          case 2:
            this.state_0 = 3;
            this.result_0 = this.local$$receiver.emit_11rb$(this.result_0, this);
            if (this.result_0 === COROUTINE_SUSPENDED)
              return COROUTINE_SUSPENDED;
            continue;
          case 3:
            return Unit;
          default:this.state_0 = 1;
            throw new Error('State Machine Unreachable execution');
        }
      } catch (e) {
        if (this.state_0 === 1) {
          this.exceptionState_0 = this.state_0;
          throw e;
        } else {
          this.state_0 = this.exceptionState_0;
          this.exception_0 = e;
        }
      }
     while (true);
  };
  function map$lambda(closure$transform_0) {
    return function ($receiver_0, value_0, continuation_0, suspended) {
      var instance = new Coroutine$map$lambda(closure$transform_0, $receiver_0, value_0, this, continuation_0);
      if (suspended)
        return instance;
      else
        return instance.doResume(null);
    };
  }
  function Coroutine$subFlow$lambda(closure$sub_0, it_0, continuation_0) {
    CoroutineImpl.call(this, continuation_0);
    this.exceptionState_0 = 1;
    this.local$closure$sub = closure$sub_0;
    this.local$it = it_0;
  }
  Coroutine$subFlow$lambda.$metadata$ = {kind: Kotlin.Kind.CLASS, simpleName: null, interfaces: [CoroutineImpl]};
  Coroutine$subFlow$lambda.prototype = Object.create(CoroutineImpl.prototype);
  Coroutine$subFlow$lambda.prototype.constructor = Coroutine$subFlow$lambda;
  Coroutine$subFlow$lambda.prototype.doResume = function () {
    do
      try {
        switch (this.state_0) {
          case 0:
            return this.local$closure$sub(this.local$it);
          case 1:
            throw this.exception_0;
          default:this.state_0 = 1;
            throw new Error('State Machine Unreachable execution');
        }
      } catch (e) {
        if (this.state_0 === 1) {
          this.exceptionState_0 = this.state_0;
          throw e;
        } else {
          this.state_0 = this.exceptionState_0;
          this.exception_0 = e;
        }
      }
     while (true);
  };
  function subFlow$lambda(closure$sub_0) {
    return function (it_0, continuation_0, suspended) {
      var instance = new Coroutine$subFlow$lambda(closure$sub_0, it_0, continuation_0);
      if (suspended)
        return instance;
      else
        return instance.doResume(null);
    };
  }
  function subFlow($receiver, contextScope, sub) {
    if (contextScope === void 0)
      contextScope = KVScope;
    return stateIn(new unsafeFlow$ObjectLiteral(unsafeTransform$lambda(map$lambda(subFlow$lambda(sub)), $receiver)), contextScope, SharingStarted.Companion.Eagerly, sub($receiver.value));
  }
  var package$io = _.io || (_.io = {});
  var package$kvision = package$io.kvision || (package$io.kvision = {});
  var package$core = package$kvision.core || (package$kvision.core = {});
  Object.defineProperty(package$core, 'KVScope', {get: function () {
    return KVScope;
  }});
  $$importsForInline$$['kotlinx-coroutines-core'] = $module$kotlinx_coroutines_core;
  $$importsForInline$$['kvision-js-legacy'] = $module$kvision_js_legacy;
  var package$state = package$kvision.state || (package$kvision.state = {});
  package$state.initWidgetScope_pbzkfn$ = initWidgetScope;
  package$state.bind_3iry3w$ = bind;
  package$state.subFlow_jgs8v8$ = subFlow;
  KVScope = CoroutineScope(coroutines.Dispatchers.Default.plus_1fupul$(SupervisorJob()));
  return _;
}));

//# sourceMappingURL=kvision-kvision-state-flow-js-legacy.js.map
